import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MODAL_STATE_TYPE {
  visible: boolean;
  name: string;
}

const INITIAL_STATE: MODAL_STATE_TYPE = { visible: false, name: '' };

const modalSlice = createSlice({
  name: 'modal',
  initialState: INITIAL_STATE,
  reducers: {
    setModalVisible(state: MODAL_STATE_TYPE, action: PayloadAction<boolean>) {
      state.visible = action.payload;
    },
    setModalName(state: MODAL_STATE_TYPE, action: PayloadAction<string>) {
      state.name = action.payload;
    },
    resetModalSlice(state: MODAL_STATE_TYPE) {
      state.visible = INITIAL_STATE.visible;
      state.name = INITIAL_STATE.name;
    },
  },
});

export const { setModalVisible, setModalName, resetModalSlice } = modalSlice.actions;
export default modalSlice.reducer;
